import { enUS, fr } from 'react-day-picker/locale'

export function resolveDatePickerLocale(language?: string) {
  return language?.toLowerCase().startsWith('fr') ? fr : enUS
}
